// @ts-nocheck


import CommonApi from '../commonApi';

import { downloadRequestWithToken } from './index';

const basedUrl = 'tripDrivingQuality';
const tripDrivingQuality = new CommonApi(
  basedUrl,
  'детализация по качеству вождения'
);

export const print = async (tripId) => {
  const print = await downloadRequestWithToken(`/${basedUrl}/${tripId}/print`);
  if (print) return print;
  throw new Error('Не удалось загрузить файл');
};

export default {
  ...tripDrivingQuality,
  print
};